import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.6rem;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 1vh;\n  margin-top: 1vh;\n  width: 60%;\n  height: 1px;\n  background: #adadc8;\n  height: 1px;\n  background: #adadc8;\n  margin: auto ;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        '\n  border-radius: 1rem;\n  border: "2px solid #FFFFFF";\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import styled, { useTheme } from "styled-components";
import Text from "../../components/Text/Text";
import Box from "../../components/Box/Box";
import { SattButton } from "../../components/Button";
import { ModalBody, ModalCloseButton, ModalContainer, ModalHeader } from "../Modal";
import SattInput from "../../components/Input/SattInput";
import useConnectSatt from "../../hooks/useConnectSatt";
import FacebookIcon from "../../components/Svg/Icons/Facebook";
import GoogleIcon from "../../components/Svg/Icons/Google";
import TelegramIcon from "../../components/Svg/Icons/TelegramConnect";
import SattLogo from "../../components/Svg/Icons/SattLogo";
var SattSpan = styled.div.withConfig({
    componentId: "sc-b1ff953f-0"
})(_templateObject());
var SattButtonConnect = styled(SattButton).withConfig({
    componentId: "sc-b1ff953f-1"
})(_templateObject1());
var WalletWrapper = styled(Box).withConfig({
    componentId: "sc-b1ff953f-2"
})(_templateObject2());
var SattConnectModal = function(param) {
    var _onDismiss = param.onDismiss, onDismiss = _onDismiss === void 0 ? function() {
        return null;
    } : _onDismiss;
    var ref = useState(""), sattEmail = ref[0], setSattEmail = ref[1];
    var ref1 = useState(""), sattPassword = ref1[0], setSattPassword = ref1[1];
    var ref2 = useState(false), isWorning = ref2[0], setIsWorning = ref2[1];
    var ref3 = useState(""), statusText = ref3[0], setStatusText = ref3[1];
    var sattLogin = useConnectSatt().sattLogin;
    var handleEmailChange = function(event) {
        setIsWorning(false);
        setSattEmail(event.target.value);
    };
    var handlePassChange = function(event) {
        setIsWorning(false);
        setSattPassword(event.target.value);
    };
    var onPressConnectSatt = function() {
        var _ref = _async_to_generator(function() {
            var ref, ref1, res, ref2, ref3, errorMsg;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            sattLogin(sattEmail, sattPassword)
                        ];
                    case 1:
                        res = _state.sent();
                        if (res === null || res === void 0 ? void 0 : (ref = res.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.error) {
                            ;
                            errorMsg = res === null || res === void 0 ? void 0 : (ref2 = res.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.error.message;
                            setStatusText(errorMsg);
                            setIsWorning(true);
                            return [
                                2
                            ];
                        }
                        onDismiss();
                        return [
                            2
                        ];
                }
            });
        });
        return function onPressConnectSatt() {
            return _ref.apply(this, arguments);
        };
    }();
    var theme = useTheme();
    var background = theme.colors.dropdown;
    var textcolor = theme.isDark ? "#7D9CD1" : "#0B3D91";
    var connectbtt = theme.isDark ? "rgba(125, 156, 209, 0.3)" : "#0B3D91";
    return /*#__PURE__*/ _jsxs(ModalContainer, {
        background: background,
        minWidth: "400px",
        children: [
            /*#__PURE__*/ _jsxs(ModalHeader, {
                children: [
                    /*#__PURE__*/ _jsx(SattLogo, {
                        mr: "1rem"
                    }),
                    /*#__PURE__*/ _jsx(ModalCloseButton, {
                        onDismiss: onDismiss
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalBody, {
                width: [
                    "400px",
                    null,
                    "400px"
                ],
                my: "2rem",
                children: [
                    /*#__PURE__*/ _jsxs(WalletWrapper, {
                        px: "2rem",
                        maxHeight: "453px",
                        overflowY: "auto",
                        children: [
                            /*#__PURE__*/ _jsx(Box, {
                                my: "1rem",
                                children: /*#__PURE__*/ _jsxs(SattButton, {
                                    width: "100%",
                                    onClick: onPressConnectSatt,
                                    bgColor: "#1967FF",
                                    children: [
                                        /*#__PURE__*/ _jsx(FacebookIcon, {
                                            mr: "0.5rem"
                                        }),
                                        "Connect with Facebook"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Box, {
                                my: "1rem",
                                children: /*#__PURE__*/ _jsxs(SattButton, {
                                    width: "100%",
                                    onClick: onPressConnectSatt,
                                    bgColor: "#FFFFFF",
                                    color: "#757575",
                                    children: [
                                        /*#__PURE__*/ _jsx(GoogleIcon, {
                                            mr: "1rem"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: "Connect with Google"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Box, {
                                my: "1rem",
                                children: /*#__PURE__*/ _jsxs(SattButton, {
                                    width: "100%",
                                    onClick: onPressConnectSatt,
                                    bgColor: "#29b6f6",
                                    children: [
                                        /*#__PURE__*/ _jsx(TelegramIcon, {}),
                                        "Connect with Telegram"
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(SattSpan, {}),
                    /*#__PURE__*/ _jsxs(WalletWrapper, {
                        px: "1rem",
                        maxHeight: "500px",
                        overflowY: "auto",
                        children: [
                            /*#__PURE__*/ _jsx(Box, {
                                my: "1rem",
                                children: /*#__PURE__*/ _jsx(SattInput, {
                                    onChange: handleEmailChange,
                                    placeholder: "Email",
                                    p: "24px"
                                })
                            }),
                            /*#__PURE__*/ _jsxs(Box, {
                                my: "1rem",
                                children: [
                                    /*#__PURE__*/ _jsx(SattInput, {
                                        onChange: handlePassChange,
                                        placeholder: "Password",
                                        type: "password"
                                    }),
                                    isWorning && /*#__PURE__*/ _jsx(Box, {
                                        my: "10px",
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            color: "red",
                                            textAlign: "center",
                                            children: statusText
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Box, {
                                py: "1rem",
                                children: /*#__PURE__*/ _jsx(SattButtonConnect, {
                                    width: "100%",
                                    onClick: onPressConnectSatt,
                                    bgColor: connectbtt,
                                    children: "Connect Satt Wallet"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        mb: "1rem",
                        mx: "1.5rem",
                        color: textcolor,
                        fontSize: "12px",
                        as: "a",
                        href: "https://dapp.satt.io/FAQ",
                        target: "_blank",
                        children: "Forgot Password ?"
                    })
                ]
            })
        ]
    });
};
export default SattConnectModal;
